import { AxiosResponse } from 'axios';
import { axiosAuthInstance } from '../../instance.ts';
import { IMeData } from './types.ts';

const UserAPI = {
  getMe: (): Promise<AxiosResponse<IMeData, void>> => axiosAuthInstance.get('user/me/'),
};

export default UserAPI;
